<div class="body">

    <app-issue-status-diff></app-issue-status-diff>

</div>